import { PreviousRouteService } from './../../../../../../shared/src/lib/service/previous-route.service';
import { ExerciceSheetService } from './../../../../../../shared/src/lib/service/exerciceSheet.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ExerciceSheet } from '../../../../../../shared/src/lib/model/exerciceSheet.model';

@Component({
  selector: 'app-assigned-sheet-detail',
  templateUrl: './assigned-sheet-detail.component.html',
  styleUrls: ['./assigned-sheet-detail.component.scss', '../../../sheets/sheet-detail/sheet-detail.component.scss']
})
export class AssignedSheetDetailComponent implements OnInit {
  sheet: ExerciceSheet = null;
  previousUrl
  constructor(
    private route: ActivatedRoute,
    private exerciceSheetService: ExerciceSheetService,
    private previousRouteService: PreviousRouteService,
  ) { }

  ngOnInit() {
    const sheetId = this.route.snapshot.params.id;
    this.getSheet(sheetId);
    this.previousUrl = this.previousRouteService.getPreviousUrl();
  }

  getSheet(sheetId) {
    this.exerciceSheetService.getExerciceSheetById(sheetId).subscribe(data => {
      if (data) {
        this.sheet = data;
      }
    })
  }

}
